export default __webpack_public_path__ + "static/media/sketch.4f16cccf.svg";